import Status from "../components/status";
import notFoundIcon from "../icons/notfound.svg"

export default () => {
    return <div className={"page"} style={{height: "calc(100vh - 32px)"}}>
        <Status
            icon={notFoundIcon}
            title={"Не удалось провести операцию"}
            subtitle={"Повторите попытку позже"}/>
    </div>
}